import labels from 'constants/labels';
import React from 'react';

function PricingToolkitIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testId={labels.header.pricingToolKit}
    >
      <circle cx="12" cy="12" r="9.35" fill="#FCFCFC" stroke="#303641" strokeWidth="1.3" />
      <path
        d="M6.91574 8.92H9.22574C9.63241 8.92 9.99908 8.95667 10.3257 9.03C10.6524 9.10333 10.9324 9.22333 11.1657 9.39C11.3991 9.55667 11.5791 9.77 11.7057 10.03C11.8324 10.29 11.8957 10.6033 11.8957 10.97C11.8957 11.3633 11.8224 11.6933 11.6757 11.96C11.5291 12.2267 11.3291 12.4433 11.0757 12.61C10.8291 12.77 10.5391 12.8867 10.2057 12.96C9.87241 13.0333 9.51908 13.07 9.14574 13.07H8.17574V16H6.91574V8.92ZM9.05574 12.01C9.26241 12.01 9.45908 11.9967 9.64574 11.97C9.83241 11.9367 9.99908 11.8833 10.1457 11.81C10.2924 11.73 10.4091 11.6233 10.4957 11.49C10.5824 11.3567 10.6257 11.1833 10.6257 10.97C10.6257 10.7633 10.5824 10.5967 10.4957 10.47C10.4091 10.3367 10.2924 10.2333 10.1457 10.16C10.0057 10.0867 9.84241 10.04 9.65574 10.02C9.47574 9.99333 9.28908 9.98 9.09574 9.98H8.17574V12.01H9.05574ZM14.3907 10.02H12.2207V8.92H17.8207V10.02H15.6507V16H14.3907V10.02Z"
        fill="#373741"
      />
    </svg>
  );
}

export default PricingToolkitIcon;
